export enum InputTypePattern {
  all,
  lettersOnly,
  digitsOnly,
  lettersOnlyWithSpace,
  digitsAndComma
}
